import React from 'react';
import { Spinner } from './CircularSpinner.styles';
import { propTypes, defaultProps, propDescriptions } from './CircularSpinner.props';

const CircularSpinner = ({ color, size, dataId }) => <Spinner data-id={dataId} data-testid={dataId} {...{ color, size }} />;

CircularSpinner.propTypes = propTypes;
CircularSpinner.defaultProps = defaultProps;
CircularSpinner.propDescriptions = propDescriptions;

export default CircularSpinner;
